import { takeLatest, put, call } from 'redux-saga/effects';
import { history, storage } from '@commons';
import { isDateValidVerifyDateBetween, formatDateDDMMYYYY } from '@components/common/format';
import { CONFIG_SESSION } from '@handler/common/startSession/actionTypes';

import {
  createControlePragaDoenca,
  updateControlePragaDoenca,
  attachFilesControlePragaDoenca,
  deleteFilesControlePragaDoenca
} from '../service';
import {
  CREATE_CONTROLE_PRAGA_DOENCA,
  CREATE_CONTROLE_PRAGA_DOENCA_PENDING,
  CREATE_CONTROLE_PRAGA_DOENCA_SUCCESS,
  CREATE_CONTROLE_PRAGA_DOENCA_FAILURE
} from '../actionTypes';

import { AlertSuccess, AlertError, AlertWarning } from '@components/common/AlertToast';
import { trackingEventCX } from '@handler/tracking/customerX/trackingEvent';
import { MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX/moduleActionEnum';

function* sagaCreateControlePragaDoenca(action) {
  yield put({ type: CREATE_CONTROLE_PRAGA_DOENCA_PENDING })

  try {
    // Valida se a data está dentro do período da safra ativa
    const safraAtiva = JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva;
    const dateFrom = safraAtiva.dataInicial;
    const dateTo = safraAtiva.dataFinal;
    const dateCheck = action.data.dataRegistro;

    if (!isDateValidVerifyDateBetween(dateFrom, dateTo, dateCheck)) {
      // Usa os valores originais se disponíveis, caso contrário usa action.data
      const registroParaPreservar = action.data._originalValues || action.data;
      yield put({ type: CREATE_CONTROLE_PRAGA_DOENCA_FAILURE, registro: registroParaPreservar });
      AlertWarning('Data informada fora do período da safra ativa. Período deve ser entre '
        + formatDateDDMMYYYY(dateFrom) + ' até ' + formatDateDDMMYYYY(dateTo) + '!');
      return;
    }

    let registro = null
    let idControlePragaDoenca = null

    if (action.data.id === undefined || action.data.id === null) {
      const response = yield call(createControlePragaDoenca, action.data)
      registro = response.data || response
      idControlePragaDoenca = registro.id

      // Anexar arquivos após a criação
      if (idControlePragaDoenca && action.data.filesToUploadList && action.data.filesToUploadList.length > 0) {
        yield call(attachFilesControlePragaDoenca, idControlePragaDoenca, action.data.filesToUploadList)
      }

      trackingEventCX('action', MODULE_ACTIONS_ENUM.CONTROLE_PRAGA_DOENCA_CRIAR);
      AlertSuccess('Cadastro realizado com sucesso!')
    } else {
      idControlePragaDoenca = action.data.id
      const response = yield call(updateControlePragaDoenca, action.data)
      registro = response.data || response

      // Anexar novos arquivos
      if (action.data.filesToUploadList && action.data.filesToUploadList.length > 0) {
        yield call(attachFilesControlePragaDoenca, idControlePragaDoenca, action.data.filesToUploadList)
      }

      // Deletar arquivos marcados
      if (action.data.filesToDeleteList && action.data.filesToDeleteList.length > 0) {
        yield call(deleteFilesControlePragaDoenca, idControlePragaDoenca, action.data.filesToDeleteList)
      }

      trackingEventCX('action', MODULE_ACTIONS_ENUM.CONTROLE_PRAGA_DOENCA_EDITAR);
      AlertSuccess('Alteração realizada com sucesso!')
    }

    yield put({ type: CREATE_CONTROLE_PRAGA_DOENCA_SUCCESS, registro: registro })

    history.push('/agricultura/controle-pragas-doencas');

  } catch (error) {

    // Usa os valores originais se disponíveis, caso contrário usa action.data
    const registroParaPreservar = action.data._originalValues || action.data;
    yield put({ type: CREATE_CONTROLE_PRAGA_DOENCA_FAILURE, registro: registroParaPreservar })
    AlertError('Falha ao salvar o registro! Tente novamente...');
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchCreateControlePragaDoenca() {
  yield takeLatest(CREATE_CONTROLE_PRAGA_DOENCA, sagaCreateControlePragaDoenca)
}
